var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{ref:"submitBtn",class:[
    'submit-btn-wrap',
    'space-between',
    _vm.isTurbo ? 'gameTurbo' : '',
    _vm.browser,
    _vm.isMobile ? '' : 'desktop',
  ]},[_c('div',{class:['price-container', _vm.region]},[_c('div',{key:`payPrice1${_vm.payPrice}`,class:['pay-price', _vm.payPriceClass]},[_c('span',[_vm._v(_vm._s(_vm.text.payPricePrefix))]),_vm._v(" "+_vm._s(_vm.formattedPrice)+"\n    ")]),_vm._v(" "),(!_vm.isMyWallet)?_c('div',{key:`originalPrice1${_vm.originalPrice}`,staticClass:"original-price"},[_vm._v("\n      "+_vm._s(_vm.text.originalPriceText)+":\n      "),_c('money-display',{attrs:{"number":Number(_vm.originalPrice),"allowShowKcoin":false}})],1):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"submit-btn"},[_c('div',{class:[
        'submitBtn',
        _vm.readyToSubmit ? '' : 'disabled',
        _vm.isTurbo ? 'gameTurbo' : '',
        _vm.isLoading ? 'btnLoading' : '',
      ],style:(_vm.readyToSubmit ? _vm.submitBtnStyle : null),on:{"click":_vm.click}},[_c('span',[_vm._v(_vm._s(_vm.text.submitText))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }